export default "__VITE_ASSET__nqSf8TVS__"